import { Component } from '@angular/core';

@Component({
  selector: 'app-apoio-cultural',
  templateUrl: './apoio-cultural.component.html',
  styleUrls: ['./apoio-cultural.component.scss']
})
export class ApoioCulturalComponent {
  secoesCulturais: any[] = [
    {
      titulo: 'Ballet Educere',
      texto: 'Aulas gratuitas de dança contemporânea para jovens e adultos que sempre quiseram dançar, mas nunca tiveram a oportunidade de aprender.',
      imagens: [
        'assets/imagens/apoio-cultural/ballet_educere_cortado.jpg',
        'assets/imagens/apoio-cultural/Ballet_Educere2_cortado.jpg',
        'assets/imagens/apoio-cultural/Ballet_Educere3_cortado.jpg'
      ],
      icone: 'assets/imagens/apoio-cultural/sapatilha.png'
    },
    {
      titulo: 'Ateliê de Escultura',
      texto: 'O curso é voltado a estudantes de 12 a 16 anos e tem o objetivo de ensinar a arte da escultura, oferecendo aulas gratuitas de desenho artístico e modelagem em argila, com material todo incluso gratuitamente.',
      imagens: [
        'assets/imagens/apoio-cultural/Escultura_cortado.png',
        'assets/imagens/apoio-cultural/Escultura2_cortado.png',
        'assets/imagens/apoio-cultural/Escultura3_cortado.png'
      ],
      icone: 'assets/imagens/apoio-cultural/escultura_icon.png'
    },
    {
      titulo: 'Orquestra e Coral',
      texto: 'Curso voltado aos jovens e adultos com objetivo de ensinar a arte do canto e da música de forma gratuita.',
      imagens: [
        'assets/imagens/apoio-cultural/CarpeDiem.jpeg',
        'assets/imagens/apoio-cultural/CarpeDiem2_cortado.png',
        'assets/imagens/apoio-cultural/CarpeDiem3_cortado.png'
      ],
      icone: 'assets/imagens/apoio-cultural/orquestra.png'
    }
  ];
}